import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1q5xt82q: FaireBrandEntity = {
  token: "b_1q5xt82q",
  type: "brand",
  name: "Earth Mama Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/7729653376bb9b977dee4fde88bfaa911cf5eac1b9e0bc96f443c0e494c22105.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e12ae4fa760e84f3c58c17a3f09a0265cb28933e851dcc079ddfc5c59e7f79c8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7729653376bb9b977dee4fde88bfaa911cf5eac1b9e0bc96f443c0e494c22105.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e12ae4fa760e84f3c58c17a3f09a0265cb28933e851dcc079ddfc5c59e7f79c8.jpeg",
  location: "Cincinnati, OH, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 182,
  isInsider: true,
  description:
    "EARTH MAMA \nGrounded in Nature, Powered by Love. ® \n\nFor over two decades, Earth Mama has combined generations of women’s wisdom, traditional herbal remedies, and evidence-based research to safely support pregnant and breastfeeding women, and their families.\n\nFounded in 2002 by a nurse and herbalist, Earth Mama’s products are formulated with effective organic ingredients and are safe for everyone, including pregnant and breastfeeding women, and their families. Trusted by mamas worldwide, Earth Mama combines generations of women’s wisdom, traditional herbal remedies, and evidence-based research to formulate certified organic herbal teas, castile-based soaps, balms, lotions, deodorants, sunscreen and more. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:59.373Z",
    importedBy: "entity-db-cli",
  },
};
